import React, { useRef,useEffect } from "react";
import ReactPlayer from "react-player";
import video from '../../assets/video/TrainingPriceListUpload.mp4';

const PriceListUploadTraining = (props) => {
    const playerRef = useRef(null);
    useEffect(()=>{
        //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    console.log(currentUser.urls);
    console.log(window.location.pathname);
    currentUser.urls.forEach(ur=>{
      
      if (ur==window.location.pathname){
        validate=true;
      }
    });
    if (validate==false){
      /*const { history } = props;
        history.push({
          pathname: '/' 
        });*/
    }
    //end validate
    },[]);
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                padding: '40px 60px'
            }}
        >
            <ReactPlayer
            url={video}
            controls={true}
            width="100%"
            height="100%"
        />
        </div>
    )
}

export default PriceListUploadTraining;
